import { Button, Col, Form, Row } from 'antd';
import { DocumentCard } from 'cmt-ui-kit';
import usePatientLoginForm from '../hooks/usePatientLoginForm';
import LogoBlanco2023 from '../../images/LogoBlanco2023.svg';
import ByMuvu from '../../PatientLandingGeneralComponents/ByMuvu';
import { useTranslation } from 'react-i18next';

const PatientLogin = ({ getPatientData, countryCode }) => {
  const { t } = useTranslation();
  const patientLoginForm = usePatientLoginForm({ getPatientData, countryCode });

  return (
    <Form form={patientLoginForm.form} onFinish={(values) => patientLoginForm.onFinishForm(values)}>
      <Row className='patient-landing-container mt-50 mr-30 ml-30' justify="center">
        <div className="orange-triangle" />
        <Col span={24}>
          <Row justify="center">
            <Col span={24} className="text-center">
              <div className="logo">
                <img src={LogoBlanco2023} alt="Logo CMT salud" height={56} />
              </div>
            </Col>
            <Col lg={24} span={24} md={24} xs={24} className="mt-20">
              <h2 className="mb-0 italic-title text-center">Te damos la bienvenida a</h2>
              <h2 className='text-white text-center mt-0'>Centro Médico del Trabajador</h2>
            </Col>
            <Col span={24} xs={24} sm={20} lg={12} md={12} xl={6} className="mt-10">
              <p className='text-center text-white mr-40 ml-40'>
              {t('patientLandingPage.patientLogin.subTitle')}
              </p>
            </Col>
          </Row>
        </Col>
        <Col span={24} className="document-input-wrapper">
          <Row justify="center">
            <Col span={24} xs={20} sm={12} lg={6} md={8} xl={6}>
              <p className='text-left'>
                Tipo y número de documento
              </p>
            </Col>
          </Row>
          <Row justify="center">
            <Col span={24} xs={20} sm={12} lg={6} md={8} xl={6}>
              <DocumentCard
                countryCode={countryCode?.toUpperCase()}
                setDocumentType={patientLoginForm.setDocumentType}
                form={patientLoginForm.form}
                type='person'
              />
            </Col>
          </Row>
        </Col>
        {
          patientLoginForm.documentType === 'rut' &&
          <Col span={24} xs={20} sm={12} lg={6} md={8} xl={6} className='mt-10'>
            <p className='instruction-text text-left'>
              Tu RUT debe ir con guión y dígito verificador
            </p>
          </Col>
        }
        <Col span={24} className="mt-40">
          <Row justify="center">
            <Col span={24} xs={12} sm={6} lg={4} md={6} xl={4}>
              <Form.Item>
                <Button className="cmt-button primary" htmlType='submit' type="primary" size="large" loading={getPatientData.isLoading}>
                  Siguiente
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <ByMuvu />
        </Col>
      </Row>
    </Form>
  )
}

export default PatientLogin;